const u = (id) => `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=1400&q=80`;

export const INSTAGRAM_HANDLE = "ulyanashmidt";
export const INSTAGRAM_URL = "https://www.instagram.com/ulyanashmidt/";
export const CONTACT_EMAIL = "shmidtulyana@gmail.com";
export const WHATSAPP_NUMBER = "13477030817";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Hello Ulyana! I'd like to book a styling consultation.")}`;

export const HERO_IMAGE = "/looks/hero-steps.jpg";
export const ABOUT_IMAGE = "/looks/boho-1.jpg";

export const NAV = [
  { label: "Services", href: "#services" },
  { label: "Clients", href: "#clients" },
  { label: "Process", href: "#process" },
  { label: "About", href: "#about" },
  { label: "Instagram", href: "#instagram" },
];

export const SERVICES = [
  {
    id: "from-scratch",
    num: "01",
    tag: "Signature service",
    short: "Style from Scratch",
    title: "Style & Wardrobe from Scratch",
    cover: u("1577020914435-7ae6b1091ebd"),
    lead: "A complete personal style, built around you — your body, your lifestyle, your next chapter.",
    text: "For women who feel their clothes no longer reflect who they are. We define your silhouettes, colours and signature pieces, then build a wardrobe that works together from day one.",
    includes: [
      "Personal style & lifestyle consultation",
      "Colour, silhouette and proportion analysis",
      "Guided shopping — in store or online",
      "A ready-to-wear lookbook of complete outfits",
    ],
    looks: [],
  },
  {
    id: "wardrobe-edit",
    num: "02",
    tag: "Most practical",
    short: "Wardrobe Edit",
    title: "Wardrobe Edit & Capsule Wardrobe",
    board: { src: "/looks/capsule-board.jpg", title: "One capsule, dozens of outfits", note: "Six looks built from a single edited capsule — blazers, shirts, trousers, knitwear, outerwear, bags, shoes and accessories that all work together." },
    lead: "New outfits from the clothes you already own.",
    text: "We go through your closet together, keep what serves you, let go of what doesn't, and combine your existing pieces into fresh, fashionable looks. The result is a clear capsule wardrobe and a short list of what is truly missing.",
    includes: [
      "In-home closet review, item by item",
      "New outfit combinations from existing pieces",
      "A capsule wardrobe plan with photos",
      "A precise shopping list of missing essentials",
    ],
    looks: [
      { src: u("1603400521630-9f2de124b33b"), title: "The edit", note: "A calm, curated rail — only what you love and wear." },
      { src: u("1558769132-cb1aea458c5e"), title: "Tonal capsule", note: "Knitwear and neutrals that all combine." },
      { src: u("1490481651871-ab68de25d43d"), title: "Light & easy", note: "Seasonal pieces reorganised for quick mornings." },
      { src: u("1551232864-3f0890e580d9"), title: "Outerwear system", note: "Five jackets, endless combinations." },
    ],
  },
  {
    id: "couple",
    num: "03",
    tag: "For two",
    short: "Couple Styling",
    title: "Couple Styling",
    lead: "Look like a pair — never like a costume.",
    text: "Coordinated styling for couples: for events, photoshoots, travel or everyday life. We harmonise colours, textures and level of formality so you look effortless together while each of you stays true to your own style.",
    includes: [
      "Joint consultation for both partners",
      "Colour and texture harmony — no matchy-matchy",
      "Outfits for events, photoshoots and travel",
      "Shopping and fitting for both",
    ],
    looks: [
      { src: "/looks/couple-evening.jpg", title: "Evening black", note: "Feathered dress and velvet tuxedo jacket — one palette, two personalities." },
      { src: "/looks/couple-autumn.jpg", title: "Autumn in the city", note: "Camel, olive and argyle knit — warm earth tones in harmony." },
      { src: "/looks/couple-white.jpg", title: "Summer white", note: "Open-knit textures and espadrilles, cream on cream." },
      { src: "/looks/couple-blue.jpg", title: "Shades of blue", note: "Powder blazer and denim meet cornflower and Breton stripes." },
      { src: "/looks/couple-marina.jpg", title: "Riviera stripes", note: "Nautical stripes, navy and white — playful but coordinated." },
    ],
  },
];

export const STEPS = [
  { num: "01", title: "Free introduction call", text: "We talk about your goals, lifestyle and what you'd like to change. No pressure, no obligation." },
  { num: "02", title: "Consultation & analysis", text: "Colours, silhouettes, proportions and your existing wardrobe — we find what works for you." },
  { num: "03", title: "Shopping & styling", text: "Together or with my preparation in advance, we select and combine the pieces." },
  { num: "04", title: "Your lookbook", text: "You receive photos of every outfit, so getting dressed becomes simple every single day." },
];

export const CLIENTS = [
  { src: "/clients/black-fringe.jpg", title: "Modern black", note: "Leather-trimmed blazer, fringe skirt and combat boots." },
  { src: "/clients/zebra-red-heels.jpg", title: "Zebra & red", note: "Graphic midi skirt, sharpened by red accents." },
  { src: "/clients/plaid-city.jpg", title: "City layers", note: "Velvet crop jacket over a plaid skirt-trouser." },
  { src: "/clients/zebra-blazer.jpg", title: "Polished print", note: "Gold-button blazer, zebra midi and tall boots." },
  { src: "/clients/red-leather.jpg", title: "Head-to-toe red", note: "Belted leather coat, tights and patent pumps." },
  { src: "/clients/floral-dress.jpg", title: "Soft occasion", note: "Printed midi dress with sheer organza sleeves." },
  { src: "/clients/beach-blue.jpg", title: "Weekend blues", note: "Powder-blue layers, striped linen and sneakers." },
  { src: "/clients/burgundy-dots.jpg", title: "Burgundy & dots", note: "Monochrome bordeaux with playful polka-dot trousers." },
  { src: "/clients/black-kaftan.jpg", title: "Evening ease", note: "Silk kaftan dress, statement jewellery and a classic bag." },
  { src: "/clients/stripes-navy.jpg", title: "Red accents", note: "Striped blouse over a tiered navy skirt." },
];

export const FEED = [
  "/looks/boho-2.jpg",
  "/looks/beach-palm.jpg",
  "/looks/red-gloves-cafe.jpg",
  "/looks/couple-burgundy.jpg",
  "/looks/couple-cabin.jpg",
];

export const MARQUEE = ["Style from scratch", "Wardrobe edit", "Capsule wardrobe", "Couple styling", "New York", "Women 40+", "By appointment"];
